import { Heading, Text } from '@checkatrade/web-ui';

import SelectCardBrowseList from '../svg/SelectCardBrowseList';
import SelectCardStars from '../svg/SelectCardStars';
import { ChevronRightSmall } from '@cat-home-experts/mortar-iconography-web/ChevronRightSmall';

import {
  useJobRefinementState,
  HIDE_RAQ_OPTIONS,
  DISMISS,
} from '../JobRefinement.reducer';
import { useJobRefinement } from '../JobRefinement.hook';
import { colors } from '@checkatrade/web-ui/themes';

export const RAQOptions = () => {
  const { state, dispatch } = useJobRefinementState();
  const { openJobSummary } = useJobRefinement();

  const onBrowseTradeList = () => {
    dispatch({ type: DISMISS });
  };

  const onPickTrades = async () => {
    openJobSummary('search');
    dispatch({ type: HIDE_RAQ_OPTIONS });
  };

  if (!state.showRaqOptions) return null;

  return (
    <>
      <p className="my-4 text-xl font-semibold text-default-700 md:text-center md:text-2xl">
        How do you want to find a tradesperson?
      </p>
      <div className="text-default flex flex-col items-center">
        <button
          className="flex w-full max-w-md flex-col items-center rounded-lg border-2 border-solid border-accent-5 p-4"
          onClick={onBrowseTradeList}
        >
          <div className="mb-4 flex w-full items-center justify-center rounded-lg bg-accent-5 py-4">
            <SelectCardBrowseList />
          </div>
          <div className="flex">
            <div className="w-full text-left">
              <Heading
                as="h3"
                weight="bold"
                variant="titleLG"
                className="text-base text-default-700 md:text-lg"
              >
                Browse our list of tradespeople
              </Heading>
              <Text className="text-sm text-default-700 md:text-base">
                View the profiles of local tradespeople and choose the ones
                you’d like to contact
              </Text>
            </div>
            <div className="hidden items-center justify-center md:flex">
              <ChevronRightSmall color={colors.secondary[100]} size={30} />
            </div>
          </div>
        </button>
        <button
          className="mt-4 flex w-full max-w-md flex-col items-center rounded-lg border-2 border-solid border-accent-5 p-4"
          onClick={onPickTrades}
        >
          <div className="mb-4 flex w-full items-center justify-center rounded-lg bg-accent-5 py-4">
            <SelectCardStars />
          </div>
          <div className="flex">
            <div className="w-full text-left">
              <Heading
                as="h3"
                weight="bold"
                variant="titleLG"
                className="text-base text-default-700 md:text-lg"
              >
                Pick tradespeople for me
              </Heading>
              <Text className="text-sm text-default-700 md:text-base">
                Leave it to us! We’ll send your job to local, vetted
                tradespeople – then it’s over to you
              </Text>
            </div>
            <div className="hidden items-center justify-center md:flex">
              <ChevronRightSmall color={colors.secondary[100]} size={30} />
            </div>
          </div>
        </button>
      </div>
    </>
  );
};

export default RAQOptions;
